import { takeLatest, put } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { apiCall } from '../../effects';
import {
  getPaymentMethodRequest,
  getPaymentMethodSuccess,
  getPaymentMethodFail,
  getInvoicesRequest,
  getInvoicesSuccess,
  getInvoicesFail,
  checkCheckoutProductsRequest,
  createNewInvoiceRequest,
  createNewInvoiceSuccess,
  createNewInvoiceFail,
} from './actions';
import BillingService from '../../../services/BillingService';
import history from "../../../history";
import {getCurrentUserRequest, getUserRequest} from "../users/actions";
import { notify } from '../notifications/actions';
import { getErrorNotification } from '../../util';
import { updateQuery } from '../../../utility/helpers';

function* getPaymentMethod({ payload }: ReturnType<typeof getPaymentMethodRequest>) {
  try {
    const paymentMethodResponse = yield apiCall(BillingService.getPaymentMethod, payload);
    if (paymentMethodResponse.valid_method_found) {
      yield put(getPaymentMethodSuccess(paymentMethodResponse));
    } else {
      yield put(getPaymentMethodFail());
    }
  } catch (e) {
    yield put(getPaymentMethodFail());
  }
}

function* getInvoices({ payload }: ReturnType<typeof getInvoicesRequest>) {
  try {
    const invoices = yield apiCall(BillingService.getInvoices, payload);
    yield put(getInvoicesSuccess(invoices));
  } catch (e) {
    yield put(getInvoicesFail());
  }
}

function* checkCheckoutProducts({ payload }: ReturnType<typeof checkCheckoutProductsRequest>) {
  try {
    const { products } = yield apiCall(BillingService.checkoutReadyProducts, payload);
    if (products && products.length) {
      yield put(push('/dashboard/plans/checkout', { productCode: products[0].product_code }));
    }
  } catch (e) {
  }
}

function* createCustomInvoice({ payload }: ReturnType<typeof createNewInvoiceRequest>) {
  try {
    yield apiCall(BillingService.createCustomInvoice, payload);

    yield put(createNewInvoiceSuccess());

    if (payload.charge_immediately) {
      // set draft
      updateQuery({ status: 'open' });
    } else {
      updateQuery({ status: 'draft' });
      // set unpaid
    }
    if (history.location.pathname.search('profile') !== -1) {
      yield put(getCurrentUserRequest());
    } else {
      yield put(getUserRequest(payload.user_id));
    }
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(createNewInvoiceFail());
  }
}

export default [
  takeLatest(getPaymentMethodRequest.type, getPaymentMethod),
  takeLatest(getInvoicesRequest.type, getInvoices),
  takeLatest(checkCheckoutProductsRequest.type, checkCheckoutProducts),
  takeLatest(createNewInvoiceRequest.type, createCustomInvoice),
];
